import { render, staticRenderFns } from "./HomeComponent.vue?vue&type=template&id=468f7fbb&"
import script from "./HomeComponent.vue?vue&type=script&lang=ts&"
export * from "./HomeComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports